export function empty() {
	const links = Array.from( document.querySelectorAll('a[href=""], a[href="#"], a:not([href])') );

	console.info(`There are ${links.length} empty links on this page`, links);

	return links;
}

/**
 *
 * @returns
 */
export function external( target = '_blank' ) {
	const links = Array.from(document.querySelectorAll('a[href]:not([target])')).filter((link) => {
		const href = link.getAttribute( 'href' ).trim();
		const isEmpty = href === '';
		const isLocal = href.indexOf(document.location.origin) === 0;
		const isAnchor = href.indexOf('#') === 0;

		if ( isEmpty || isLocal || isAnchor ) {
			return false;
		}

		return true;
	});

	if ( target ) {
		links.forEach( link => {
			if ( target && ! link.getAttribute( 'target' ) ) {
				link.target = target;
			}
		} );
	}

	console.info( 'External Links', links )

	return links;
}
